<template>
  <div>
    <v-snackbar v-model="showSnackbar" :timeout="5000" :color="snackbarColor">
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="showSnackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>

    <v-row class="ma-0 my-4 align-center justify-space-between">
      <h1 class="text-h5 font-weight-bold">Clínicas Droopy</h1>
    </v-row>

    <v-card class="pa-6 mb-6">
      <v-card-title class="text-uppercase">Alta de clínica</v-card-title>
      <hr class="my-3" />
      <v-card-text>
        <v-form ref="clinicForm" v-model="formValid">
          <v-row class="my-1">
            <v-col cols="4">
              <v-text-field
                label="Nombre de la clínica"
                v-model="clinicForm.name"
                :rules="nameRules"
                required
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                label="RUT"
                v-model="clinicForm.rut"
                :rules="rutRules"
                required
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                label="Email del administrador"
                v-model="clinicForm.adminEmail"
                :rules="emailRules"
                required
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="justify-end">
            <v-col cols="auto">
              <v-btn
                :disabled="!formValid || creatingClinic"
                :loading="creatingClinic"
                color="primary"
                rounded
                @click="createClinicAdministrator"
              >
                Crear cuenta de administrador
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <v-card class="pa-6" v-if="clinic">
      <v-card-title class="text-uppercase">
        Servicios de {{ clinic.name }}
      </v-card-title>
      <hr class="my-3" />
      <v-card-text>
        <clinic-services-maintainer :clinic-id="clinic.clinicId"></clinic-services-maintainer>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import UsersService from '../services/users.service';
import RutUtils from '../utils/rut.utils';
import { utilsMixin } from '../mixins/utilsMixin';
import ClinicServicesMaintainer from '../components/ClinicServicesMaintainer.vue';

// El backend ya valida NAME_REQUIRED/RUT_REQUIRED/INVALID_RUT_FORMAT/ADMIN_EMAIL_REQUIRED
// (ver 063-clinic-admin-onboarding, pawer-backend) — este diccionario solo traduce esos
// códigos a algo que el equipo Pawer entienda, sin duplicar la regla de negocio acá.
const CREATE_CLINIC_ERROR_MESSAGES = {
  NAME_REQUIRED: 'El nombre de la clínica es obligatorio.',
  RUT_REQUIRED: 'El RUT es obligatorio.',
  INVALID_RUT_FORMAT: 'El RUT ingresado no tiene un formato válido.',
  ADMIN_EMAIL_REQUIRED: 'El email del administrador es obligatorio.'
};

export default {
  name: 'ClinicOnboarding',

  components: { ClinicServicesMaintainer },

  mixins: [utilsMixin],

  data() {
    return {
      formValid: false,
      creatingClinic: false,
      clinic: null,
      clinicForm: {
        name: '',
        rut: '',
        adminEmail: ''
      },
      nameRules: [v => !!v || 'El nombre es requerido'],
      rutRules: [
        v => !!v || 'El RUT es requerido',
        v => RutUtils.validateRut(v) || 'RUT no válido'
      ],
      emailRules: [
        v => !!v || 'El email es requerido',
        v => /.+@.+\..+/.test(v) || 'Debe ser un email válido'
      ],
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: ''
    };
  },

  methods: {
    async createClinicAdministrator() {
      if (!this.$refs.clinicForm.validate()) return;

      this.creatingClinic = true;
      const response = await UsersService.createManualUser('clinic', { ...this.clinicForm });
      this.creatingClinic = false;

      if (response.status === 'ok') {
        this.clinic = response.data;
        this.showSuccessSnackbar(
          `Cuenta de administrador creada para ${this.clinic.name}.`
        );
      } else {
        this.showErrorSnackbar(this.mapCreateClinicError(response));
      }
    },

    mapCreateClinicError(response) {
      if (response.httpCode === 409) {
        return 'Esta clínica ya tiene una cuenta de administrador.';
      }
      return (
        CREATE_CLINIC_ERROR_MESSAGES[response.message] ||
        'Ocurrió un error al crear la clínica. Intenta nuevamente.'
      );
    }
  }
};
</script>
